import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@agissc/ktag-map';
import classNames from 'classnames';

interface Props {
  additionalClassNames?: string;
  tooltipOpen?: string;
  tooltipClose?: string;
  onOpen: () => void;
  onClose: () => void;
}

const AccordionToggle = ({
  onOpen,
  onClose,
  additionalClassNames,
  tooltipOpen,
  tooltipClose,
}: Props) => {
  const { t } = useTranslation('agisviewer');
  return (
    <div className={classNames('accordion__toggle-buttons', additionalClassNames)}>
      <Button onClick={onOpen} title={tooltipOpen} additionalClassNames="button__as-link">
        {t('accordion_expand_all')}
      </Button>
      <Button
        onClick={onClose}
        title={tooltipClose}
        additionalClassNames="button__as-link"
      >
        {t('accordion_collapse_all')}
      </Button>
    </div>
  );
};

export default AccordionToggle;
